module.exports = __webpack_public_path__ + "static/pexels-2-960fd6b85cb4324808156aee8d52e55c.png";